import * as loginAction from './../../store/auth/login/actions'

import React, { useEffect } from "react"

import { useDispatch } from "react-redux";
import {useHistory} from 'react-router-dom';

function Logout() {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(loginAction.logout(history))
  }, [])
  return <React.Fragment></React.Fragment>
}

export default Logout


